/**
 * The FHIR resource types the Admin panel can inspect. These mirror the
 * versioned `supported_resource_types` on the FHIR server.
 */
export interface AdminResourceType {
  /** FHIR resourceType (as used in the URL path). */
  type: string;
  /** Human-friendly label for the picker. */
  label: string;
}

export const ADMIN_RESOURCE_TYPES: AdminResourceType[] = [
  { type: "Patient", label: "Patient" },
  { type: "Encounter", label: "Encounter" },
  { type: "Condition", label: "Condition (Problem)" },
  { type: "MedicationRequest", label: "Medication Request (Rx)" },
  { type: "MedicationStatement", label: "Medication Statement" },
  { type: "AllergyIntolerance", label: "Allergy" },
  { type: "Observation", label: "Observation" },
  { type: "Immunization", label: "Immunization" },
  { type: "Procedure", label: "Procedure" },
  { type: "Goal", label: "Goal" },
  { type: "CarePlan", label: "Care Plan" },
  { type: "CareTeam", label: "Care Team" },
  { type: "EpisodeOfCare", label: "Episode of Care (Medical History)" },
  { type: "DiagnosticReport", label: "Diagnostic Report" },
  { type: "ServiceRequest", label: "Service Request" },
  { type: "DocumentReference", label: "Document" },
  { type: "FamilyMemberHistory", label: "Family History" },
  { type: "QuestionnaireResponse", label: "Questionnaire Response" },
  { type: "Coverage", label: "Coverage (Insurance)" },
  { type: "Flag", label: "Flag" },
  { type: "RequestGroup", label: "Request Group" },
];

export const getResourceType = (type?: string): AdminResourceType | undefined =>
  ADMIN_RESOURCE_TYPES.find((r) => r.type === type);
